import { ResendReleasePaymentHoldEntity } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldEntity";
import { EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA, ResendReleasePaymentHoldSearchCriteria } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldSearchCriteria";
import { ResendReleasePaymentHoldRepository } from "domain/repository/ResendReleasePaymentHold/ResendReleasePaymentHoldRepo";
import _ from "lodash";
import { ResendReleasePaymentHoldModel } from "presentation/model/ResendReleasePaymentHold/ResendReleasePaymentHoldModel";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface ResendReleasePaymentHoldVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<ResendReleasePaymentHoldModel>> | ((value: SetStateAction<ResendReleasePaymentHoldModel>) => void),
    ],
    repo: ResendReleasePaymentHoldRepository,
}

export const ResendReleasePaymentHoldVM = ({ dispatch, repo }: ResendReleasePaymentHoldVMProps) => {
    const [resendReleasePaymentHoldMainDispatch] = dispatch;

    const onSearchClick = async () => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel
            }
        });
    }

    const onRemoveAllSearchCriteria = async () => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_RESEND_RELEASE_PAYMENT_HOLD_SEARCH_CRITERIA }
            }
        });
    }
    const onSearch = async (criteria: ResendReleasePaymentHoldSearchCriteria) => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: criteria,
                // resendReleasePaymentHoldList: []
            }
        });
        await repo.getEntities(criteria).then((data) => {
            resendReleasePaymentHoldMainDispatch(prevState => {
                return {
                    ...prevState,
                    resendReleasePaymentHoldList: data,
                    isAllowAutoSearch: false,
                    searchCriteria: criteria,
                }
            });
        });
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: (fieldKey === 'actionCode' || fieldKey === 'status') ? val : val?.toString().trim().toUpperCase(),
                },
            }
        })
    }

    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        resendReleasePaymentHoldMainDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [dateFields.startField]: startDate,
                [dateFields.endField]: endDate,
            }
        }))
    }

    const onTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>, fieldName: string, toUpperCase: boolean = false) => {
        const val = toUpperCase ? e.target.value.toUpperCase() : e.target.value;

        resendReleasePaymentHoldMainDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: val === "" ? null : val.split(',')
            },
        }))
    }

    const updateSelectedRows = async (rows: any[]) => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onResend = async (rows: ResendReleasePaymentHoldEntity[]) => {
        return await repo.resend(rows);
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }

    const onUpdAgentDelivery = () => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            let agentDeliveryDate = null;
            prevState.selectedRows?.forEach(row => {
                if (row.agentDeliveryOrderDate) {
                    agentDeliveryDate = row.agentDeliveryOrderDate;
                }
            })
            return {
                ...prevState,
                isShowUpdatePanel: true,
                agentDeliveryDate: agentDeliveryDate,
            }
        })
    }

    const onCloseUpdatePanel = () => {
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                isShowUpdatePanel: false,
            }
        })
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        resendReleasePaymentHoldMainDispatch(prevState => {
            return {
                ...prevState,
                [fieldKey]: val,
                allFormState: {
                    ...prevState.allFormState,
                    [fieldKey]: '',
                }
            }
        })
    }

    const onSave = async (agentDeliveryDate: Date | null) => {
        if (!agentDeliveryDate) {
            resendReleasePaymentHoldMainDispatch(prevState => {
                return {
                    ...prevState,
                    allFormState: {
                        ...prevState.allFormState,
                        agentDeliveryDate: 'Missing.',
                    }
                }
            })
        } else {
            resendReleasePaymentHoldMainDispatch(prevState => {
                let table = [...prevState.resendReleasePaymentHoldList];
                let selectedRows = prevState.selectedRows;

                table = table.map(row => {
                    if (selectedRows.some(selectedRow => selectedRow.id === row.id)) {
                        return {
                            ...row,
                            agentDeliveryOrderDate: agentDeliveryDate
                        };
                    }
                    return row;
                });

                return {
                    ...prevState,
                    resendReleasePaymentHoldList: table,
                    isShowUpdatePanel: false,
                };
            });
        }
    }

    return {
        onResend: onResend,
        updateSelectedRows: updateSelectedRows,
        onSearchClick: onSearchClick,
        onRemoveAllSearchCriteria: onRemoveAllSearchCriteria,
        onSearch: onSearch,
        onSearchFieldChange: onSearchFieldChange,
        onDateRangeChange: onDateRangeChange,
        onTextAreaChange: onTextAreaChange,
        setIsSearchLoading: setIsSearchLoading,
        onUpdAgentDelivery: onUpdAgentDelivery,
        onCloseUpdatePanel: onCloseUpdatePanel,
        onFieldChange: onFieldChange,
        onSave: onSave,
    }
}